module.exports = __webpack_public_path__ + "static/media/af-institution.1167aff3.png";